import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui";
import { Plus } from "lucide-react";
import { useBillingInfo, useIsProCloudPlan } from "../../../store/userStore";
import { usePenpal } from "../../../hooks/usePenpal";
import { useUserStore } from "../../../store/userStore";
import { useUIStore } from "../../../store/uiStore";
import UpsellModal from "../../modals/UpsellModal";
import { LimitReachedAlert } from "../portal/LimitReachedAlert";

interface HelpCentersPageHeaderProps {
  onCreateClick: () => void;
}

export const HelpCentersPageHeader: React.FC<HelpCentersPageHeaderProps> = ({
  onCreateClick,
}) => {
  const { t } = useTranslation();
  const isProCloudPlan = useIsProCloudPlan();
  const billingInfo = useBillingInfo();
  const { account } = useUserStore();
  const { openExternalUrl } = usePenpal();
  const { modals, closeModal } = useUIStore();

  const handleUpgradeClick = () => {
    const url =
      "https://folge.me/go/cloud?cloudemail=" +
      encodeURIComponent(account?.email || "") +
      "#pricing";
    openExternalUrl(url);
  };

  const helpCentersLimit = billingInfo?.helpCentersLimit ?? 1;
  const helpCenterCreated = billingInfo?.helpCenterCreated ?? 0;
  const isAtLimit = !isProCloudPlan && helpCenterCreated >= helpCentersLimit;

  return (
    <>
      <UpsellModal
        isOpen={modals.upsell}
        onClose={() => closeModal("upsell")}
      />
      <div className="flex justify-between items-center mb-4">
        <div>
          <h1 className="text-xl font-bold text-foreground">{t("helpCenter.pageHeader.title")}</h1>
          <p className="text-muted-foreground mt-1 text-sm">
            {t("helpCenter.pageHeader.description")}
          </p>
        </div>
        <Button
          onClick={onCreateClick}
          className="flex items-center gap-2"
          disabled={isAtLimit}
        >
          <Plus className="h-4 w-4" />
          {t("helpCenter.pageHeader.createButton")}
        </Button>
      </div>
      {!isProCloudPlan && (
        <div className="mb-4">
          <LimitReachedAlert
            message={`${t("helpCenter.pageHeader.limitMessage", { count: helpCentersLimit, created: helpCenterCreated })}${isAtLimit ? t("helpCenter.pageHeader.limitReachedSuffix") : ''}`}
            onUpgradeClick={handleUpgradeClick}
          />
        </div>
      )}
    </>
  );
};

